export function permissionDeviceDetails(stream) {
  const camera = stream.getVideoTracks().map(track => track.label || 'Não identificado');
  const microphone = stream.getAudioTracks().map(track => track.label || 'Não identificado');
  return JSON.stringify({
    mensagem: `Câmera: ${camera.join(', ') || 'Sem câmera'} | Microfone: ${microphone.join(', ') || 'Sem microfone'}`,
    cameras: camera,
    microfones: microphone,
  });
}
